import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { useState } from "react";

export const TeamApplicationStatusDialog = ({
    children,
    teamId,
    status,
}: {
    children: React.ReactNode;
    teamId: any;
    status: any;
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [applicationStatus, setStatus] = useState(status.data.status);

    const handleApplicationStatus = async () => {
        const response = await fetch(`__SITE_BASE__/api/v1/teams/${teamId}/applications/status`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ enabled: !applicationStatus }),
        });

        if (response.ok) {
            status.refetch();
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <div onClick={() => setIsOpen(true)}>
                    {children}
                </div>
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 rounded-lg px-0">
                <DialogHeader className="items-center justify-center">
                    <DialogTitle>Application Status</DialogTitle>
                </DialogHeader>
                <div className="flex flex-col gap-4 items-center justify-center p-4">
                    <div className="flex flex-col w-full items-center justify-center gap-4">
                        <div className="flex items-center justify-between w-full bg-brand-default px-6 py-4 rounded-lg">
                            <div className="flex flex-col items-start">
                                <Label className="text-white">Application Enabled</Label>
                                <p className="text-gray-300 text-sm">
                                    If disabled, users will not be able to submit applications.
                                </p>
                            </div>
                            <div
                                className={`relative inline-flex items-center cursor-pointer`}
                                onClick={() => {
                                    setStatus(!applicationStatus);
                                    handleApplicationStatus();
                                }}
                            >
                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    checked={applicationStatus}
                                    onChange={() => {}}
                                />
                                <div
                                    className={`block w-14 h-8 rounded-full ${
                                        applicationStatus ? 'bg-brand-green' : 'bg-brand-profile'
                                    }`}
                                >
                                    <div
                                        className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${
                                            applicationStatus ? 'translate-x-6' : 'translate-x-0'
                                        }`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
